interface BadgeListProps {
  /** Every badge on the role's ladder, in order, with whether it is earned. */
  badges: { id: string; label: string; earned: boolean }[];
}

/** Earned and unearned side by side — the empty slots are the point. */
export default function BadgeList({ badges }: BadgeListProps) {
  return (
    <div className="badges">
      {badges.map(badge => (
        <span key={badge.id} className={`badge ${badge.earned ? 'on' : 'off'}`}>
          <span aria-hidden="true">{badge.earned ? '◆' : '◇'}</span>
          {badge.label}
        </span>
      ))}
    </div>
  );
}
